export default "__VITE_ASSET__a015c957__"